import { render, staticRenderFns } from "./BottomButtons.vue?vue&type=template&id=458ac1a4"
import script from "./BottomButtons.vue?vue&type=script&lang=js"
export * from "./BottomButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports